import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FiPhone,
  FiFacebook,
  FiInstagram,
  FiMenu,
  FiX,
  FiLinkedin
} from 'react-icons/fi';
import './Header.css';
import logo from '../assets/unnamed.jpg';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="site-header">
      {/* DESKTOP / TABLET TOPBAR */}
      <div className="topbar">
        <div className="topbar-inner">
          <div className="topbar-left">
            <FiPhone className="topbar-icon" />
            <span className="topbar-text">Devis gratuit :</span>
            <a href="tel:0765551111" className="topbar-phone">
              07 65 55 11 11
            </a>
            <a href="mailto:contact@plus-propre.fr" className='head-mail'>
              contact@plus-propre.fr
            </a>
          </div>
          <div className="topbar-right">
            <a href="https://www.facebook.com/people/Pluspropre/61576653958810/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FiFacebook />
            </a>
            <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fpropre-nettoyage%2Fabout%2F%3FviewAsMember%3Dtrue" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FiLinkedin />
            </a>
            <a href="https://www.instagram.com/plus_propre.fr/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FiInstagram />
            </a>
          </div>
        </div>
      </div>

      <nav className="mainnav">
        <div className="mainnav-inner">
          <div className="brand">
            <img src={logo} alt="+Propre" className="header-logo" />
            <div className="brand-text">
              <span className="brand-sub">Nettoyage professionnel · Strasbourg</span>
            </div>
          </div>

          <ul className="menu">
            <li><NavLink end to="/" className="menu-link">Accueil</NavLink></li>
            <li><NavLink to="/a-propos" className="menu-link">À propos</NavLink></li>
            <li><NavLink to="/realisations" className="menu-link">Services</NavLink></li>
            <li><NavLink to="/devis" className="nav-cta">Demander un devis</NavLink></li>
          </ul>

          <button
            className="acc-mobile-burger"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </nav>

      {/* MOBILE PANEL OVERLAY */}
      <div
        className={`acc-mobile-overlay ${mobileOpen ? 'open' : ''}`}
        onClick={() => setMobileOpen(false)}
      />

      {/* MOBILE SLIDE PANEL */}
      <aside className={`acc-mobile-panel ${mobileOpen ? 'open' : ''}`}>
        {/* TOPBAR ПЕРЕНЕСЁН ВНУТРЬ МОБИЛЬНОГО МЕНЮ */}
        <div className="acc-mobile-topbar">
          <div className="topbar-left">
            <FiPhone className="topbar-icon" />
            <span className="topbar-text">Devis gratuit :</span>
            <a href="tel:0765551111" className="topbar-phone">
              07 65 55 11 11
            </a>
            <a href="mailto:contact@plus-propre.fr" className='head-mail'>
              contact@plus-propre.fr
            </a>
          </div>
          <div className="topbar-right">
            <a href="https://www.facebook.com/people/Pluspropre/61576653958810/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FiFacebook />
            </a>
            <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fpropre-nettoyage%2Fabout%2F%3FviewAsMember%3Dtrue" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FiLinkedin />
            </a>
            <a href="https://www.instagram.com/plus_propre.fr/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FiInstagram />
            </a>
          </div>
        </div>

        <nav className="acc-mobile-links">
          <NavLink end to="/" onClick={() => setMobileOpen(false)}>Accueil</NavLink>
          <NavLink to="/a-propos" onClick={() => setMobileOpen(false)}>À propos</NavLink>
          <NavLink to="/realisations" onClick={() => setMobileOpen(false)}>Services</NavLink>
          <NavLink
            to="/devis"
            className="acc-mobile-cta"
            onClick={() => setMobileOpen(false)}
          >
            Demander un devis
          </NavLink>
        </nav>
      </aside>
    </header>
  );
}
